// extracted by mini-css-extract-plugin
export default {"container":"adminBetPortal_container__8EgmT","top":"adminBetPortal_top__4s35s","btn":"adminBetPortal_btn__813cN","postContainer":"adminBetPortal_postContainer__0p-TD"};